<template>
  <div class="container">
    <div class="row">
      <div class="col-12" id="banner">
        <img :src="this.$site + '/img/parceiros/' + id + '/' + dados_parceiro.banner" class="img-fluid w-100" alt="">
      </div>
    </div>
    <div class="container my-4">
      <div class="row g-2">
        <div class="col-lg-10 offset-lg-1">
          <img :src="this.$site + '/img/parceiros/' + id + '/' + dados_parceiro.logo" class="img-fluid logo" alt="">
          <span class="align-middle fs-2 fw-bold ms-3">
            {{ dados_parceiro.nome_empresa }}
          </span>
        </div>
      </div>
      <div class="row g-2 my-3">
        <div class="col-lg-7 offset-lg-1 pe-5" id="mgn" v-html="dados_parceiro.texto_inicial"></div>
        <div class="col-lg-3">
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-if="tem_endereco">
              <div class="row">
                <div class="col-2 col-sm-1 col-lg-2">
                  <i class="bi bi-building"></i>
                </div>
                <div class="col texto_descricao">
                  <small><strong>Endereço:</strong></small><br>
                  {{ endereco }}
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="dados_parceiro.email">
              <div class="row">
                <div class="col-2 col-sm-1 col-lg-2">
                  <i class="bi bi-envelope"></i>
                </div>
                <div class="col-10 texto_descricao">
                  <small><strong>Email:</strong></small><br>
                  <a class="btn texto_descricao_btn" :href="'mailto:' + dados_parceiro.email">{{ dados_parceiro.email
                  }}</a>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="dados_parceiro.telefone_empresa">
              <div class="row">
                <div class="col-2 col-sm-1 col-lg-2">
                  <i class="bi bi-telephone"></i>
                </div>
                <div class="col texto_descricao">
                  <small><strong>Telefone:</strong></small><br>
                  <a class="btn texto_descricao_btn" :href="'tel:' + dados_parceiro.telefone_empresa">{{
                    dados_parceiro.telefone_empresa }}</a>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="dados_parceiro.whatsapp_empresa">
              <div class="row">
                <div class="col-2 col-sm-1 col-lg-2">
                  <i class="bi bi-whatsapp"></i>
                </div>
                <div class="col texto_descricao">
                  <small><strong>Whatsapp:</strong></small><br>
                  <a class="btn texto_descricao_btn" target="_blank"
                    :href="'https://api.whatsapp.com/send?phone=55' + dados_parceiro.whatsapp_empresa + '&text=Entro%20em%20contato%20pelo%20site%20saiadosofabr.com.br.'">{{
                      dados_parceiro.whatsapp_empresa }}</a>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-2 col-sm-1 col-lg-2">
                  <i class="bi bi-link-45deg"></i>
                </div>
                <div class="col texto_descricao">
                  <small><strong>Redes Sociais:</strong></small><br>
                  <a :href="dados_parceiro.facebook" v-if="dados_parceiro.facebook" target="_blank">
                    <i class="bi bi-facebook"></i>
                  </a>
                  <a :href="dados_parceiro.instagram" v-if="dados_parceiro.instagram" target="_blank">
                    <i class="bi bi-instagram"></i>
                  </a>
                  <a :href="dados_parceiro.canal_youtube" v-if="dados_parceiro.canal_youtube" target="_blank">
                    <i class="bi bi-youtube"></i>
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container my-4">
      <div class="row g-2">
        <div class="col-lg-10 offset-lg-1" id="mgn">

          <Lightbox :imgs="galeria.img"></Lightbox>

        </div>
      </div>
      <div class="row g-2">
        <div class="col-lg-10 offset-lg-1" id="mgn">

          <Mapa :endereco="endereco" v-if="tem_endereco != ''"></Mapa>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Lightbox from '@/components/lightbox.vue';
import Mapa from '@/components/Mapa.vue';
import { toastr } from '@/plugins/toast';
import { api } from '@/services/api';

export default {
  name: 'Parceiro',
  data() {
    return {
      id: this.$route.params.id,
      dados_parceiro: {},
      galeria: {},
    }
  },
  components: {
    Lightbox,
    Mapa
  },
  methods: {
    async carrega_dados() {
      try {
        const dados_parceiro = await api.post('partner/list_site/' + this.id)

        if (Object.keys(dados_parceiro).length === 0) {
          // redireciona
          toastr.erro("Parceiro não existe ou não pertence mais ao grupo de parceiros.")
          this.$router.push('/')
        } else {
          this.dados_parceiro = dados_parceiro
        }
      } catch (error) {
        toastr.erro("Parceiro não existe ou não pertence mais ao grupo de parceiros.")
      }

      this.galeria = await api.post('partner/gallery/' + this.id + '/img')
    }
  },
  computed: {
    endereco: function () {
      return this.dados_parceiro.rua
        + ' ' + this.dados_parceiro.numero
        + ', Bairro ' + this.dados_parceiro.bairro
        + ' ' + this.dados_parceiro.cidade
        + ' ' + this.dados_parceiro.estado
        + ' ' + this.dados_parceiro.cep
    },
    tem_endereco: function () {
      return ((this.dados_parceiro.rua !== "" && this.dados_parceiro.rua !== undefined) &&
        (this.dados_parceiro.numero !== "" && this.dados_parceiro.numero !== undefined) &&
        (this.dados_parceiro.bairro !== "" && this.dados_parceiro.bairro !== undefined) &&
        (this.dados_parceiro.cep !== "") && this.dados_parceiro.cep !== undefined)
    },
    tem_social: function () {
      return (this.dados_parceiro.estado.facebook || this.dados_parceiro.estado.instagram || this.dados_parceiro.estado.canal_youtube)
    }
  },
  mounted() {
    this.carrega_dados()
  },
}
</script>

<style scoped>
.logo {
  max-width: 120px;
}

.bi {
  font-size: 26px !important;
  margin-right: 10px;
  color: #34b1ca;
}

a .bi {
  color: #333;
  font-size: 14px;
}

small {
  font-size: 10px;
}

.texto_descricao {
  font-size: 12px;
  color: #333;
}

.texto_descricao_btn {
  padding: 2px;
  font-size: 12px;
}
</style>